export default "/50f517735fec46580f19aae3e56e9fe21614ea75/9efedd6f8d84b8cf11b1862201b47d04.svg";